var storageHelper = () => {
	var pre = 'adyes.mobi.platform.'

	/**
	 * 统一存储实现
	 * @param  {storage} st  存储方式 localStorage/sessionStorage
	 * @param  {string} key 存储key
	 * @param  {mix} val 存储值
	 * @param  {integer} exp 存储时间（秒）
	 * @return {mix}     false或者存储值
	 */
	var storage = (st, key, val, exp) => {
		if (typeof key !== 'undefined' && !key) {
			return st.clear()
		}

		key = pre + key

		if (typeof val === 'undefined') {
			var info = st.getItem(key)
			info = JSON.parse(info)
			if (!info) {
				return false
			}
			if (info.endTime > 0 && info.endTime < (new Date()).valueOf()) {
				st.removeItem(key)
				return false
			}
			return info.data
		}

		if (!val) {
			return st.removeItem(key)
		}

		info = {}
		info.data = val
		info.endTime = exp ? (new Date()).valueOf() + exp * 1000 : 0
		return st.setItem(key, JSON.stringify(info))
	}

	// local storage
	var local = (key, val, exp) => {
		if (!window.localStorage) {
			window.alert('您的浏览器不支持本地存储，请升级或更换其他高性能浏览器')
		}
		return storage(window.localStorage, key, val, exp)
	}

	// session storage
	var session = (key, val, exp) => {
		if (!window.sessionStorage) {
			window.alert('您的浏览器不支持本地存储，请升级或更换其他高性能浏览器')
		}
		return storage(window.sessionStorage, key, val, exp)
	}

	return {
		local: local,
		session: session
	}
}

export default {
	install: function (Vue) {
		if (storageHelper.installed) {
			return
		}
		storageHelper.installed = true
		Vue.prototype.storageHelper = storageHelper()
	},

	instance: storageHelper()
}



// WEBPACK FOOTER //
// ./src/helper/storage.js